export default "__VITE_ASSET__D0CTzi4S__"